import { useMemo } from 'react';

import orderBy from 'lodash/orderBy';

import { CAST_AI } from '@cast/constants';
import { BestPracticeCheckStandard } from '@cast/types';

import { useActiveClusters } from '../../_hooks/useActiveClusters';
import { useClustersOrFixture } from '../hooks/useClustersOrFixture';
import { useGetBestPracticeComplianceStandards } from '../hooks/useGetBestPracticeComplianceStandards';

const castOptions = [
  {
    title: CAST_AI,
    value: BestPracticeCheckStandard.cast,
  },
];

type UseStandardCriteriaProps = {
  clusterIds?: string[];
};

export const useStandardCriteria = ({
  clusterIds: scopedClusterIds,
}: UseStandardCriteriaProps = {}) => {
  const { clusters: _clusters } = useActiveClusters();
  const { clusters } = useClustersOrFixture(_clusters);

  const { complianceStandards } = useGetBestPracticeComplianceStandards({
    clusterIds: scopedClusterIds,
  });

  const options = useMemo(() => {
    if (!clusters?.length) {
      return castOptions;
    }
    return orderBy(complianceStandards, ['title'], ['asc']);
  }, [clusters, complianceStandards]);

  return {
    key: 'standard',
    initialValue: BestPracticeCheckStandard.cast,
    options,
  };
};
